const dashboard = {
  total_users: "admin.dashboard_total_users",
  total_communities: "admin.dashboard_total_communities",
  total_community_posts: "admin.dashboard_total_community_posts",
  total_groups: "admin.dashboard_total_groups",
  growth_chart_title: "admin.dashboard_growth_chart_title",
  period: {
    day: "admin.dashboard_period_day",
    week: "admin.dashboard_period_week",
    month: "admin.dashboard_period_month",
    year: "admin.dashboard_period_year",
  },
  chart: {
    users: "admin.dashboard_chart_users",
    communities: "admin.dashboard_chart_communities",
    community_posts: "admin.dashboard_chart_community_posts",
    groups: "admin.dashboard_chart_groups",
  },
  messages: {
    fetch_counts_failed: "admin.dashboard_messages_fetch_counts_failed",
    fetch_chart_failed: "admin.dashboard_messages_fetch_chart_failed",
  },
};

export default dashboard;
